import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../api';
import SpecialityModal from './modals/Specialities/SpecialitiesAddModal';
import Pagination from '../Tools/Pagination';

const SpecialityTab = () => {
  const [specialities, setSpecialities] = useState([]);
  const [filter, setFilter] = useState('');
  const [formData, setFormData] = useState({ speciality_name: '', status: 1 });
  const [editId, setEditId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);

  // Fetch Specialities with pagination
  const fetchSpecialities = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get('/specialities', {
        params: {
          search: filter,
          page,
          limit
        }
      });
      const data = response.data?.data || response.data;

      setSpecialities(data.data || data);
      setTotal(data.total || data.length || 0);
    } catch (error) {
      console.error('Fetch failed:', error);
      alert('Failed to fetch specialities');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSpecialities();
  }, [filter, page]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const openAddModal = () => {
    setEditId(null);
    setFormData({ speciality_name: '', status: 1 });
    const modal = new window.bootstrap.Modal(document.getElementById('bs-specialities'));
    modal.show();
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setFormData({ speciality_name: item.speciality_name, status: 1 });
    const modal = new window.bootstrap.Modal(document.getElementById('bs-specialities'));
    modal.show();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this speciality?')) {
      try {
        await axiosInstance.delete(`/specialities/${id}`);
        alert('Deleted successfully');
        fetchSpecialities();
      } catch (err) {
        console.error('Delete failed:', err);
        alert('Failed to delete');
      }
    }
  };

  const handleSave = async () => {
    try {
      const payload = new URLSearchParams();
      payload.append('speciality_name', formData.speciality_name);
      payload.append('status', formData.status);

      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };

      if (editId) {
        await axiosInstance.put(`/specialities/${editId}`, payload, { headers });
        alert('Updated successfully');
      } else {
        await axiosInstance.post('/specialities', payload, { headers });
        alert('Added successfully');
      }

      // Close Modal
      const modalEl = document.getElementById('bs-specialities');
      const modal = window.bootstrap.Modal.getInstance(modalEl);
      modal.hide();

      fetchSpecialities();
    } catch (err) {
      console.error('Save failed:', err);
      alert('Failed to save');
    }
  };

  return (
    <div className="tab-pane active" id="specialities" role="tabpanel">
      {/* Filter Section */}
      <div className="filter-search mt-3">
        <h6 className="px-2 mb-0">Filter</h6>
        <div className="filter-panel d-flex align-items-center flex-wrap">
          <form className="flex-grow-1">
            <div className="form-group col-lg-3 col-12 p-2">
              <input
                type="text"
                className="form-control"
                placeholder="Speciality Name"
                value={filter}
                onChange={(e) => {
                  setPage(1);
                  setFilter(e.target.value);
                }}
              />
            </div>
          </form>

          <button
            className="btn m-2 d-flex align-items-center justify-content-center btn-outline-primary waves-effect waves-light"
            type="button"
            onClick={openAddModal}
          >
            <i className="ti ti-circle-plus fs-4 me-2"></i>
            Add Specialities
          </button>
        </div>
      </div>

      {/* Table Section */}
      {isLoading ? (
        <div className="text-center py-4">Loading Specialities...</div>
      ) : (
        <>
          <div className="py-3 px-0">
            <div className="table-responsive rounded-2 ros-table">
              <table className="table text-nowrap customize-table mb-0 align-middle">
                <thead className="text-dark fs-4">
                  <tr>
                    <th><h6 className="fw-semibold mb-0">ID</h6></th>
                    <th><h6 className="fw-semibold mb-0">Speciality</h6></th>
                    <th><h6 className="fw-semibold mb-0">Actions</h6></th>
                  </tr>
                </thead>
                <tbody>
                  {specialities.length > 0 ? (
                    specialities.map((spec) => (
                      <tr key={spec.id}>
                        <td>{spec.id.toString().padStart(2, '0')}</td>
                        <td>{spec.speciality_name}</td>
                        <td>
                          <button onClick={() => handleEdit(spec)} className="h4 me-3 border-0 bg-transparent">
                            <i className="ti ti-edit text-warning"></i>
                          </button>
                          <button onClick={() => handleDelete(spec.id)} className="h4 border-0 bg-transparent">
                            <i className="ti ti-trash text-danger"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4">No Specialities Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          {specialities.length > 0 && (
            <Pagination
              total={total}
              limit={limit}
              page={page}
              onPageChange={setPage}
            />
          )}
        </>
      )}

      {/* Modal */}
      <SpecialityModal
        formData={formData}
        onChange={handleChange}
        onSave={handleSave}
        editId={editId}
      />
    </div>
  );
};

export default SpecialityTab;
